import L from "leaflet";
import "leaflet/dist/leaflet.css";

const DEFAULT_CENTER = [45.582715, -122.587987];
const DEFAULT_ZOOM = 14;

function createMarkerIcon() {
    return L.icon({
        iconUrl: "https://cdn.portofportland.com/images/marker-icon.png",
        iconRetinaUrl: "https://cdn.portofportland.com/images/marker-icon-2x.png",
        iconSize: [25, 39],
        iconAnchor: [12, 39],
        popupAnchor: [0, -39]
    });
}

function buildPopup(site) {
    return `
        <div class="map-popup">
            <strong>${site.title}</strong><br />
            <a href="#"
               class="map-popup-link"
               data-bs-toggle="modal"
               data-bs-target="#${site.modalId}">
               View gallery
            </a>
        </div>
    `;
}

function initHistoricalSitesMap(mapSelector, sites = []) {
    const mapEl =
        typeof mapSelector === "string"
            ? document.querySelector(mapSelector)
            : mapSelector;

    if (!mapEl) return null;

    const map = L.map(mapEl, {
        minZoom: 10,
        maxZoom: 19,
        scrollWheelZoom: false
    }).setView(DEFAULT_CENTER, DEFAULT_ZOOM);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    const markerIcon = createMarkerIcon();
    const bounds = [];

    sites.forEach(site => {
        L.marker(site.coords, { icon: markerIcon })
            .addTo(map)
            .bindPopup(buildPopup(site));

        bounds.push(site.coords);
    });

    if (bounds.length > 1) {
        map.fitBounds(bounds, { padding: [40, 40] });
    } else if (bounds.length === 1) {
        map.setView(bounds[0], DEFAULT_ZOOM);
    }

    return map;
}

window.PortJS = window.PortJS || {};
window.PortJS.initHistoricalSitesMap = initHistoricalSitesMap;

export { initHistoricalSitesMap };